import React from "react";
import * as Mui from "@mui/material";
import { SvgIconProps } from "@mui/material/SvgIcon";

interface Props extends SvgIconProps {
	children: React.SVGAttributes<SVGAElement>;
	className?: string;
}

/**
 * Wraps a react-feather glyph in a Mui.SvgIcon so it picks up MUI sizing/color.
 *
 * MUST forward its ref (MAX-4158). This was a class component, which cannot hold one: any MUI
 * parent that clones its child and attaches a ref — Tooltip, and every ButtonBase descendant —
 * got the class *instance* instead of the <svg>. MUI's useIsFocusVisible ref callback guards only
 * `node != null`, so the instance sailed through and `prepare(node.ownerDocument)` called
 * addEventListener on undefined, killing the whole render tree (white screen, not a degraded icon).
 * Since Mui.SvgIcon is itself a forwardRef that lands on the <svg>, passing ref through is enough.
 */
const Component = React.forwardRef<SVGSVGElement, Props>((props, ref) => {
	const { children, className, ...others } = props;
	// style/className stay after the spread so they keep winning over `others`, as before.
	return (
		<Mui.SvgIcon {...others} ref={ref} style={{padding: 1, boxSizing: "border-box"}} className={className}>
			{children}
		</Mui.SvgIcon>
	);
});

Component.displayName = "FeatherIcon";

export const FeatherIcon = Component;
